import { createAsyncThunk } from '@reduxjs/toolkit';
import { CPAPFilterType } from 'components/SearchCpapPage';
import { Hexabase } from 'hexabase-sdk';
import { Condition } from 'hexabase-sdk/dist/models';
import moment from 'moment';
import { itemService } from '../../services';
import { GetMedicalSearchRequest } from '../../types';

export const getCpapInstructItems = createAsyncThunk<any, { pageNumber: number; searchValue?: CPAPFilterType | any }>(
  'cpapInstructions/getItems',
  async (params) => {
    try {
      const conditions: any[] = [];
      if (params.searchValue) {
        Object.keys(params.searchValue).forEach((key) => {
          if (params.searchValue && key) {
            const value = params.searchValue[key as keyof typeof params.searchValue];
            if (value || key === 'suspension_flg') {
              switch (key) {
                case 'installation_date':
                  const startTime = (value as [moment.Moment, moment.Moment])[0]?.startOf('day').toISOString();
                  const endTime = (value as [moment.Moment, moment.Moment])[1]?.endOf('day').toISOString();
                  conditions.push({
                    id: key,
                    search_value: [startTime, endTime],
                  });
                  break;
                case 'health_authorities_iids':
                  if (value.length == 0) {
                    break;
                  }
                  conditions.push({
                    conditions: [
                      {
                        id: 'facility_name',
                        search_value: value,
                      },
                      {
                        id: 'data_type',
                        search_value: ['dslookup'],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'suspension_flg':
                  if (value) {
                    conditions.push({
                      id: key,
                      search_value: ['1'],
                      not_match: true,
                      include_null: true,
                    });
                  }
                  break;
                case 'phone_number':
                  conditions.push({
                    conditions: [
                      {
                        id: 'phone_number',
                        search_value: [value],
                      },
                      {
                        id: 'mobile_phone_number',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'other':
                  conditions.push({
                    conditions: [
                      {
                        id: 'cpap_setting_for_search',
                        search_value: [value],
                      },
                      {
                        id: 'address_1',
                        search_value: [value],
                      },
                      {
                        id: 'transfer_history',
                        search_value: [value],
                      },
                      {
                        id: 'acc_mask_other',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'patient_name':
                  conditions.push({
                    conditions: [
                      {
                        id: 'patient_name',
                        search_value: [value],
                      },
                      {
                        id: 'patient_name_kana',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'cpap_setting_for_search':
                  conditions.push({
                    conditions: [
                      {
                        id: 'cpap_setting_for_search',
                        search_value: [value],
                      },
                      {
                        id: 'machine_other',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'health_authorities':
                  break;
                default:
                  conditions.push({
                    id: key,
                    search_value: [value],
                  });
                  break;
              }
            }
          }
        });
      }
      const response = await itemService.filterCPAP({
        per_page: 20,
        page: params.pageNumber,
        conditions,
        disable_sort_num: true,
        disable_include_links: true,
        disable_include_lookups: true,
      });

      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
);

export const getCpapInstructItemsExport = createAsyncThunk<any, { searchValue?: CPAPFilterType }>(
  'cpapInstructions/getItemsExport',
  async (params) => {
    try {
      const conditions: any[] = [];
      if (params.searchValue) {
        Object.keys(params.searchValue).forEach((key) => {
          if (params.searchValue && key) {
            const value = params.searchValue[key as keyof typeof params.searchValue];
            if (value || key === 'suspension_flg') {
              switch (key) {
                case 'installation_date':
                  const startTime = (value as [moment.Moment, moment.Moment])[0]?.startOf('day').toISOString();
                  const endTime = (value as [moment.Moment, moment.Moment])[1]?.endOf('day').toISOString();
                  conditions.push({
                    id: key,
                    search_value: [startTime, endTime],
                  });
                  break;
                case 'health_authorities_iids':
                  if (Array.isArray(value) && value.length == 0) {
                    break;
                  }
                  conditions.push({
                    conditions: [
                      {
                        id: 'facility_name',
                        search_value: value,
                      },
                      {
                        id: 'data_type',
                        search_value: ['dslookup'],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'suspension_flg':
                  if (value) {
                    conditions.push({
                      id: key,
                      search_value: ['1'],
                      not_match: true,
                      include_null: true,
                    });
                  }
                  break;
                case 'phone_number':
                  conditions.push({
                    conditions: [
                      {
                        id: 'phone_number',
                        search_value: [value],
                      },
                      {
                        id: 'mobile_phone_number',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'other':
                  conditions.push({
                    conditions: [
                      {
                        id: 'cpap_setting_for_search',
                        search_value: [value],
                      },
                      {
                        id: 'address_1',
                        search_value: [value],
                      },
                      {
                        id: 'transfer_history',
                        search_value: [value],
                      },
                      {
                        id: 'acc_mask_other',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'patient_name':
                  conditions.push({
                    conditions: [
                      {
                        id: 'patient_name',
                        search_value: [value],
                      },
                      {
                        id: 'patient_name_kana',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                case 'cpap_setting_for_search':
                  conditions.push({
                    conditions: [
                      {
                        id: 'cpap_setting_for_search',
                        search_value: [value],
                      },
                      {
                        id: 'machine_other',
                        search_value: [value],
                      },
                    ],
                    use_or_condition: true,
                  });
                  break;
                default:
                  conditions.push({
                    id: key,
                    search_value: [value],
                  });
                  break;
              }
            }
          }
        });
      }
      const response = await itemService.filterCPAP({
        per_page: 0,
        page: 1,
        conditions,
        disable_sort_num: true,
        disable_include_links: true,
        disable_include_lookups: true,
      });

      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
);

export const getListMedicalSearch = createAsyncThunk<
  any,
  { pageNumber: number; searchValue?: GetMedicalSearchRequest }
>('cpapInstructions/getItems/search', async (params) => {
  try {
    const conditions: Condition[] = [];
    params.searchValue?.health_authorities &&
      conditions.push({
        search_value: [params.searchValue?.health_authorities],
        data_type: 'text',
        id: 'in_charge_of_sales',
        exact_match: false,
        include_null: false,
      });

    const MedicalItemsSearch = await Hexabase.items().getItemsAsync({
      project_id: 'CPAP',
      datastore_id: 't_medical_institution',
      per_page: 0,
      page: params.pageNumber,
      use_display_id: true,
      sort_field_id: 'created_at',
      sort_order: 'desc',
      conditions: params.searchValue ? conditions : undefined,
    });
    return MedicalItemsSearch;
  } catch (e) {
    console.log(e);
  }
});
